module.exports = "../fonts/iconfont.ttf?ecbd6e3a9f81a18c464326ec67ed7331";